import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53f99160")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_v_image = _resolveComponent("v-image")

  return (_openBlock(), _createBlock("div", {
    class: "v-image",
    ref: "container",
    style: _ctx.containerStyle
  }, [
    (_ctx.videoSrc)
      ? (_openBlock(), _createBlock("video", {
          key: 0,
          ref: "video",
          preload: "auto",
          style: {"display":"none"},
          onLoadeddata: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.videoLoad && _ctx.videoLoad(...args))),
          src: _ctx.videoSrc
        }, null, 40, ["src"]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: "v-image-container",
      style: _ctx.containerImageStyle
    }, [
      (_ctx.imageSrc&&!_ctx.useVideo&&_ctx.status !== _ctx.imageStatus.fail)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            src: _ctx.imageSrc,
            onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLoadSuccess && _ctx.onLoadSuccess(...args))),
            onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onLoadFail && _ctx.onLoadFail(...args))),
            ref: "image",
            alt: "image",
            class: ["v-image-style", _ctx.imageClassStyle],
            style: _ctx.imageStyle
          }, null, 46, ["src"]))
        : _createCommentVNode("", true),
      (_ctx.imageSrc&&_ctx.useVideo&&_ctx.status !== _ctx.imageStatus.fail)
        ? (_openBlock(), _createBlock("video", {
            key: 1,
            src: _ctx.imageSrc,
            poster: _ctx.usePoster,
            preload: _ctx.usePoster?'meta':'auto',
            controls: _ctx.controls,
            "webkit-playsinline": "",
            controlslist: "nodownload nofullscreen noremoteplayback",
            oncontextmenu: "return false",
            onLoadeddata: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onLoadSuccess && _ctx.onLoadSuccess(...args))),
            onError: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onLoadFail && _ctx.onLoadFail(...args))),
            ref: "image",
            class: ["v-image-style", _ctx.imageClassStyle],
            style: _ctx.imageStyle
          }, null, 46, ["src", "poster", "preload", "controls"]))
        : _createCommentVNode("", true),
      (_ctx.icon)
        ? (_openBlock(), _createBlock("aside", {
            key: 2,
            class: "v-image-icon",
            style: _ctx.containerIconStyle
          }, [
            _createVNode(_component_v_image, {
              src: _ctx.icon,
              backgroundColor: "transparent",
              class: "v-image-icon-image",
              mode: _ctx.iconMode
            }, null, 8, ["src", "mode"])
          ], 4))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode("div", {
      class: ["v-image-slot", {'v-image-pointer':_ctx.pointer}]
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.status === _ctx.imageStatus.success)
        ? _renderSlot(_ctx.$slots, "success", { key: 0 }, undefined, true)
        : _createCommentVNode("", true),
      (_ctx.status === _ctx.imageStatus.fail)
        ? _renderSlot(_ctx.$slots, "fail", { key: 1 }, undefined, true)
        : _createCommentVNode("", true),
      (_ctx.status === _ctx.imageStatus.loading)
        ? _renderSlot(_ctx.$slots, "loading", { key: 2 }, undefined, true)
        : _createCommentVNode("", true)
    ], 2)
  ], 4))
})